import { ErrorMap } from '../../../_base/validation/ErrorMap';
import { FileInfo } from '../../../models/general/FileInfo';

export class ClaimCommentVM {
    message = '';
    errors: ErrorMap = {};
    attachments: FileInfo[] = [];
}
